import './plugins/axios'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import commonJs from "@/assets/common";
import {createPinia} from 'pinia'
import Vant from 'vant';
import 'vant/lib/index.css';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

let pinia = createPinia().use(piniaPluginPersistedstate)

app.use(commonJs).use(ElementPlus).use(Vant).use(router).use(pinia).mount('#app')
